import { useEffect } from 'react';
import { metadataTags } from './pageMetadata';

export default function PageMetadata({ meta, children }) {
  useEffect(() => {
    if (!meta) return undefined;
    const previousTitle = document.title;
    const restore = [];
    document.title = meta.title;
    metadataTags(meta).forEach(([type, attributes]) => {
      const key = type === 'link' ? 'rel' : attributes.name ? 'name' : 'property';
      let tag = document.head.querySelector(`${type}[${key}="${attributes[key]}"]`);
      const previous = tag?.cloneNode(true);
      if (!tag) { tag = document.createElement(type); document.head.appendChild(tag); }
      Object.entries(attributes).forEach(([name, value]) => tag.setAttribute(name, value));
      restore.push(() => previous ? tag.replaceWith(previous) : tag.remove());
    });
    return () => { document.title = previousTitle; restore.reverse().forEach(fn => fn()); };
  }, [meta]);
  return children;
}
